export const GEOSPATIAL_PAGE = {
  title: 'Coverage & Intelligence',
  description: 'Explore coverage and location-based insights. Use filters to scope the map',
  filtersLabel: 'Filters',
  filtersCloseLabel: 'Close',
  filtersDialogLabel: 'Map filters',
  scopeToggleHint: 'Requires a signed-in user linked to units',
} as const;
